import React from 'react';
import { Tooltip } from 'antd';

const ErrorsTooltip = ( { errors, children } ) => {

    const title = !Array.isArray( errors ) || errors.length < 1 ?
        null
        :
        <ul>
            { errors.map( error => <li key={ error.id }>{ error.message }</li> ) }
        </ul>;

    return (
        <Tooltip
            color="rgba(178, 34,34, 0.85)"
            classNames={ { root: 'file-loader-hatch-errors' } }
            title={ title }
        >
            { children }
        </Tooltip>
    );
};

export default ErrorsTooltip;